import { createStore } from 'vuex'
import axios from 'axios'

// local
//const port = 8090
//const hostadress = 'http://localhost:' + port

// Test Server
//const hostadress = 'https://opac02.bfp-ausbildung.de:' + port

// Prod
const port = 443
const hostadress = 'https://opac-api.bfp-ausbildung.de:' + port
export default createStore({
  // global store for vue application
  state: {
    results: [],
    reservation: [],
    loading: false,
  },
  // mutations are methods that change data in the state
  // only synchrone code
  mutations: {
    setResult(state, results) {
      state.results = results;
    },
    setReservation(state, reservation) {
      state.reservation = reservation;
    },
    toggleLoading(state) {
      state.loading = !state.loading;
    },
  },
  // methods to dispatch (call) asynchron api - cant change state data
  // has to commit mutations
  actions: {
    async searchByParams({ commit }, params) {
      if (params) {
        commit("toggleLoading");
        const response = await axios.post(hostadress + "/search", params);
        //console.log("call search", response);
        if (response.status == 200) {
          //console.log("call search DATA", response.data);
          setTimeout(() => {
            //console.log("1 Sek Loading", this.state.loading)
            commit("toggleLoading");
            commit("setResult", response.data);
          }, 1000);
        }
      }
    },
    async mediaById({ commit }, params) {
      if (params) {
        //http://localhost:8090/media/181145
        commit("toggleLoading");
        const response = await axios.post(hostadress + "/mediaById", params);
        //console.log("call mediaById", response);
        if (response.status == 200) {
          //console.log("call mediaById DATA", response.data);
          commit("setResult", response.data);
          commit("toggleLoading");
        }
      }
    },
    async reserveTable({ commit }, params) {
      if (params) {
        commit("toggleLoading");
        const response = await axios.post(hostadress + "/reserveTable", params);
        console.log("call reserveTable", response);
        if (response.status == 200) {
          //console.log("call search DATA", response.data);
          setTimeout(() => {
            //console.log("1 Sek Loading", this.state.loading)
            commit("toggleLoading");
            commit("setReservation", response.data);
          }, 1000);
        }
      }
    },
    async isTableReserved({ commit }, params) {
      if (params) {
        commit("toggleLoading");
        const response = await axios.post(
          hostadress + "/isTableReserved",
          params
        );
        console.log("call isTableReserved", response);
        if (response.status == 200) {
          //console.log("call search DATA", response.data);
          setTimeout(() => {
            //console.log("1 Sek Loading", this.state.loading)
            commit("toggleLoading");
            commit("setReservation", response.data);
          }, 1000);
        }
      }
    },
    async removeReservation({ commit }, params) {
      if (params) {
        commit("toggleLoading");
        const response = await axios.post(
          hostadress + "/removeReservation",
          params
        );
        if (response.status == 200) {
          setTimeout(() => {
            //console.log("1 Sek Loading", this.state.loading)
            commit("toggleLoading");
            commit("setReservation", []);
          }, 1000);
        }
      }
    },
  },
  // filter data before make them availabel in the app
  getters: {
    showResults(state) {
      return state.results && state.results.length >= 1;
    },
    showReservation(state) {
      return state.reservation && state.reservation.length >= 1;
    },
  },
});
